<template>
  <hr
    class="own-rule"
    :class="[
      `own-rule--${type}`,
      `own-rule--color-${color}`,
      !vertical && 'own-rule--horizontal',
      vertical && 'own-rule--vertical',
    ]"
  />
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    type?: 'solid' | 'dashed'
    vertical?: boolean
    color?: 'default' | 'info'
  }>(),
  {
    color: 'default',
    type: 'solid',
    vertical: false,
  }
)
</script>

<style lang="scss">
.own-rule {
  &--horizontal {
    height: 0;
    width: 100%;
    border: transparent;
    border-width: 0;
    border-top-width: 1px;
    border-top-style: solid;
  }

  &--vertical {
    width: 0;
    border: none;
    border: transparent;
    border-width: 0;
    border-left-width: 1px;
    border-left-style: solid;
  }

  &--dashed {
    border-style: dashed;
  }

  &--color {
    &-default {
      border-color: var(--divider);
    }

    &-info {
      border-color: var(--color-text-info);
      opacity: 0.1;
    }
  }
}
</style>
